import { Body, Box } from '..'
import { Button } from '.'
import { LeftArrow } from '../icons'

export const BackButton = ({ onClick }) => <>
  <Box className="desktop-only" position="absolute" top={40} left={80}>
    <Button leftIcon="LeftArrow" onClick={onClick}>
      Back
    </Button>
  </Box>
  <Box className="mobile-only" position="absolute" top={20} left={32} alignItems="center" gap={8} onClick={onClick}>
    <LeftArrow />
    <Body alt bold underline>BACK</Body>
  </Box>
</>
